import i18n from 'i18next';
// import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import { enTranslations } from 'common/translations/en';
import { chTranslations } from 'common/translations/ch';

const DEFAULT_LNG = 'en';

i18n
  // .use(XHR)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LNG,
    nsSeparator: '##',
    keySeparator: '',

    resources: {
      en: {
        translation: enTranslations,
      },
      ch: {
        translation: chTranslations,
      },
    },

    interpolation: {
      escapeValue: false, // react already safes from xss
      prefix: '{',
      suffix: '}',
    },

    backend: {
      // loadPath: 'https://localhost:4000',
    },

    fallbackLng: {
      default: [DEFAULT_LNG],
    },
  });

export default i18n;
